import { render, staticRenderFns } from "./GastroErcpEdit.vue?vue&type=template&id=f1a9cbe4"
import script from "./GastroErcpEdit.vue?vue&type=script&lang=js"
export * from "./GastroErcpEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports